import { DataMessageContent, StatsDataCellValue } from '../../../model/StatsAssistant'

/** Excel FR attend « ; » comme séparateur et un BOM pour lire l'UTF-8 (accents). */
const CSV_SEPARATOR = ';'
const UTF8_BOM = '﻿'

const escapeCsv = (value: string): string =>
  /[;"\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value

// Nombres en décimale française, sans séparateur de milliers, pour rester numériques dans Excel.
const toCsvCell = (value: StatsDataCellValue): string => {
  if (value === null) return ''
  if (typeof value === 'number') return String(value).replace('.', ',')
  return String(value)
}

export const buildResultDataCsv = ({ columns, rows }: DataMessageContent): string => {
  const header = columns.map(({ label }) => escapeCsv(label)).join(CSV_SEPARATOR)
  const body = rows.map((row) => row.map((cell) => escapeCsv(toCsvCell(cell))).join(CSV_SEPARATOR))

  return UTF8_BOM + [header, ...body].join('\r\n')
}
